import {useState} from 'react'
import useCommands from './useCommands.jsx'
import usePermission from './usePermission.mjs'

export default ({data, permission}) => {
    const [dp, setDp] = useState(data.dp)
    const [content, setContent] = useState(data.content)

    return {
        content,
        dp,
        setContent,
        setDp,
        ...useCommands(),
        ...usePermission(permission, dp),
    }
}
